$.fn.ForceImageHeight = function() {
  let self = this

  self.heightRatio = 0;
  self.pictures = self.find('.picture');
  self.width = 0;
  self.initialized = false;

  self.init = function() {
    var total = 0;
    self.pictures.each(function() {
      total += $(this).outerHeight();
      $(this).addClass('--force-image-height--picture');
    })
    var average = total / self.pictures.length
    self.ratio = average / self.width

    self.css('--force-image-height--row-ratio', self.ratio);
    self.initialized = true;
  }

  self.resize =  function() {
    self.width = $(self).width();
    self.css('--force-image-height--row-width', self.width + 'px');

    if (!$.mlmi.mobile.isMobile && !self.initialized) {
      self.init();
    }
  }

  return function() {
    $(window).on('resize orientationchange load', self.resize)
    return self
  }()
}
